import { HttpResponseError } from '../types/http-response-error';
import { HttpStatusCode } from '../types/http-status-code';
import { isResponseParsable } from './is-response-parsable';
/**
 * Parses an HTTP response based on its status code and content type.
 *
 * @returns The parsed response content, or `undefined` if the response is not parsable. Throws an [[HttpResponseError]] if the response is not successful.
 */
export const parseHttpResponse = (response) => {
    if (response.status === HttpStatusCode.NotModified)
        return undefined; // the API would have returned OK but didn't due to a cache control header.
    if (!response.ok)
        throw new HttpResponseError(response);
    if (!isResponseParsable(response))
        return undefined;
    const contentType = response.headers.get('content-type');
    if (contentType) {
        if (contentType.includes('application/json')) {
            return response.json();
        }
        else if (contentType.includes('text/')) {
            return response.text();
        }
    }
    return response.blob();
};
//# sourceMappingURL=parse-http-response.js.map